import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { RoadmapItem } from '@/models/RoadmapItem';
import GridCard from './GridCard';
import emptyState from '@/assets/empty_state.svg';
import './GridView.css';

interface GridViewProps {
    data: RoadmapItem[];
    onLike: (jiraId: string, isLiked: boolean) => void;
    onFollow: (jiraId: string, isFollowed: boolean) => void;
    isAuthenticated: boolean;
    selectedJiraId?: string | null;
    onFlyoutClose?: () => void;
}

const GridView: React.FC<GridViewProps> = ({
    data,
    onLike,
    onFollow,
    isAuthenticated,
    selectedJiraId,
    onFlyoutClose,
}) => {
    if (!data || data.length === 0) {
        return (
            <Box className="grid-view-empty" data-testid="grid-view-empty">
                <img src={emptyState} alt="No items found" className="grid-view-empty-image" />
                <Typography variant="h6" className="grid-view-empty-text">
                    No roadmap items found
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="grid-view-container" data-testid="grid-view-component">
            <Grid container spacing={2} className="grid-view-grid">
                {data.map(item => (
                    <GridCard
                        key={item.id}
                        data={item}
                        onLike={onLike}
                        onFollow={onFollow}
                        isAuthenticated={isAuthenticated}
                        selectedJiraId={selectedJiraId}
                        onFlyoutClose={onFlyoutClose}
                    />
                ))}
            </Grid>
        </Box>
    );
};

export default GridView;
